import API from "../../../api.js";
import {
  MEDICINE_LIST_REQUEST,
  MEDICINE_LIST_SUCCESS,
  MEDICINE_LIST_FAIL,
} from "../../constants/patientConstants/medicineConstants.js";

export const listMedicines = () => async (dispatch) => {
  try {
    dispatch({ type: MEDICINE_LIST_REQUEST });
    const { data } = await API.get("/medicines");
    dispatch({ type: MEDICINE_LIST_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: MEDICINE_LIST_FAIL,
      payload: error.response?.data?.msg || error.message,
    });
  }
};
